<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Client</h3>

            <div class="search_bar mb-3">
                <b-button
                    class="btn-action"
                    size="sm"
                    variant="info"
                    :to="{
                        name: 'cms_client_add'
                    }"
                    v-if="
                        $store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Client',
                                'Create',
                                true
                            )
                    "
                    >Add Client</b-button
                >
            </div>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(skip_product)="data">
                    {{ data.item.skip_product == 1 ? 'Yes' : data.item.skip_product == 0 ? 'No' : '-' }}
                </template>

                <template v-slot:cell(description)="data">
                    {{ data.item.description || '-' }}
                </template>

                <template v-slot:cell(base_url)="data">
                    {{ data.item.base_url || '-' }}
                </template>
            </b-table>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "client_name",
        label: "Client Name"
    },
    {
        key: "full_name",
        label: "Full Name"
    },
    {
        key: "description",
        label: "Shopify Description"
    },
    {
        key: "base_url",
        label: "Shopify Base URL"
    },
    {
        key: "skip_product",
        label: "Skip Product"
    }
];

export default {
    name: "CmsClient",
    mixins: [global_function],
    inject: [
        "API_HOST",
        "TABLE_LIMIT",
        "PAGING_LIMIT",
        "DEFAULT_ROWS_PER_PAGE"
    ],
    components: {
        Pagination
    },
    data() {
        return {
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            total_rows: 0,
            rows_per_page: this.DEFAULT_ROWS_PER_PAGE,
            paging_limit: this.PAGING_LIMIT,
            search_criteria: {}
        };
    },
    async created() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Client',
            'View',
            true
        )) {
            this.$router.replace('/');
            return;
        }

        await this.getClientProfile();
        this.initialized = true;
    },
    mounted() {
        if (!this.checkPermission(
            this.$store.state.user_obj,
            'Account',
            'Client',
            'View',
            true
        )) {
            return;
        }

        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    computed: {
        table_offset: function() {
            return (this.currentPage - 1) * this.rows_per_page;
        }
    },
    methods: {
        async getClientProfile() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_client_profile_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.rows_per_page,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.items = response.data.clients;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
        },

        onSearch() {
          for (const key in this.search_criteria) {
            if (typeof this.search_criteria[key] === "string") {
              this.search_criteria[key] = this.search_criteria[key].trim();
            }
          }
            this.getClientProfile();
        },

        onPageChange(page_to_change) {
            this.currentPage = page_to_change;
            this.getClientProfile();
        },

        onPerPageChange(_perPage) {
            this.currentPage = 1;
            this.rows_per_page = _perPage;
            this.getClientProfile();
        },
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsClient.vue